/**
 * Gibbs Action Registry — Public API
 *
 * @module gibbs/registry
 */

// Type system
export {
    WorkflowTypes, isTypeCompatible, getTypeDescription, getAllTypes, getCompatibilityRules,
} from './types';

// Schema types and helpers
export {
    VALID_RUNTIMES, VALID_STATUSES, CATEGORIES, validateActionDef, param, pre, post,
} from './schema';

// Precondition evaluators
export {
    preconditionEvaluators,
    evaluatePrecondition,
    getAllPreconditionIds,
    fragmentAvailabilityEvidence,
} from './preconditions';

// Registry lookups
export {
    getAction,
    getActionsByCategory,
    getAllActions,
    getActionCount,
    getActionsAcceptingInput,
    getActionsProducingOutput,
    getCompatibleNextActions,
    checkPreconditions,
} from './registry';

// Composability graph
export {
    generateComposabilityGraph,
    graphToMarkdown,
    graphToJSON,
    findPaths,
    getReachable,
} from './composabilityGraph';
